import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { api, money } from "@/lib/api";

export const RepTheKing = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/merch/products").then((r) => { const f = r.data.filter((p) => p.featured); setItems((f.length ? f : r.data).slice(0, 4)); }).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="home-rep-the-king">
      <div className="flex items-end justify-between gap-3 mb-6">
        <div>
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-amber-400 flex items-center gap-2"><Crown className="w-4 h-4" /> Rep The King</span>
          <h2 className="font-display font-black uppercase text-3xl sm:text-4xl mt-1">Official Merch</h2>
        </div>
        <button data-testid="rep-shop-all" onClick={() => navigate("/merch")} className="px-5 py-2.5 rounded-full bg-amber-400 text-[#0A2818] font-display font-black uppercase text-sm whitespace-nowrap">Shop All Merch</button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map((p) => (
          <button key={p.product_id} data-testid={`rep-item-${p.product_id}`} onClick={() => navigate("/merch")} className="group text-left rounded-2xl bg-[#181D1A] border border-emerald-900/60 overflow-hidden hover:border-amber-500/50 transition-colors">
            <div className="aspect-square overflow-hidden bg-[#101311]">
              <img src={p.images?.[0]} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-3">
              <h3 className="font-display font-bold text-sm leading-tight truncate">{p.name}</h3>
              <span className="text-amber-400 font-black text-sm">{money(p.retail_price)}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};
